import React, { Component } from "react";
import { Spin, Alert } from "antd";
import axios from "axios";
import { extraerDatosDesdeArbol, resolverProveedorPorRfc } from "./xmlConceptosHelpers";
import ConceptosXmlTable from "./ConceptosXmlTable";

// Wrapper on-demand: dado el id de un XmlDescargado, descarga y parsea el árbol para
// extraer sus conceptos y resolver el proveedor, y muestra ConceptosXmlTable. Pensado para
// usarse como expandedRowRender de una fila de tabla, de forma que solo se consulta el
// backend cuando el usuario expande esa fila puntual.
class ConceptosXmlPorXmlId extends Component {
  state = {
    loading: false,
    error: null,
    conceptos: null,
    tipoDeComprobante: null,
    rfcEmisor: null,
    nombreEmisor: null,
    monedaAbrev: null,
    todasProveedores: this.props.todasProveedores || [],
  };

  componentDidMount() {
    this.consultarXml();
  }

  consultarXml() {
    this.setState({ loading: true, error: null });
    axios
      .post("descargaMasiva/datosXml", { xmlId: this.props.xmlId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ loading: false, error: "No se pudo leer el XML" });
          return;
        }
        const datos = extraerDatosDesdeArbol(res.data.dataXml);
        this.setState({
          loading: false,
          conceptos: datos.conceptos,
          tipoDeComprobante: res.data.tipoDeComprobante,
          rfcEmisor: datos.rfcEmisor,
          nombreEmisor: datos.nombreEmisor,
          monedaAbrev: datos.monedaAbrev,
        });
      })
      .catch(() => this.setState({ loading: false, error: "No se pudo leer el XML" }));
  }

  onProveedorAlta(proveedorNuevo) {
    this.setState((prev) => ({ todasProveedores: [...prev.todasProveedores, proveedorNuevo] }));
    if (this.props.onProveedorAlta) this.props.onProveedorAlta(proveedorNuevo);
  }

  render() {
    const { loading, error, conceptos, tipoDeComprobante, rfcEmisor, nombreEmisor, monedaAbrev, todasProveedores } = this.state;

    if (loading) return <Spin spinning={true} />;
    if (error) return <Alert type="error" showIcon message={error} />;
    if (tipoDeComprobante !== "I" && tipoDeComprobante !== "E") {
      return <Alert type="info" showIcon message="Este comprobante no es una factura de ingreso/egreso" />;
    }

    const proveedor = resolverProveedorPorRfc(todasProveedores, rfcEmisor);

    return (
      <ConceptosXmlTable
        empresaId={this.props.empresaId}
        headersToken={this.props.headersToken}
        proveedorId={proveedor?._id}
        proveedorRfc={rfcEmisor}
        proveedorNombre={nombreEmisor}
        monedaAbrev={monedaAbrev}
        todasTiposDeProveedor={this.props.todasTiposDeProveedor}
        todasMonedas={this.props.todasMonedas}
        conceptos={conceptos}
        onProveedorAlta={this.onProveedorAlta.bind(this)}
      />
    );
  }
}

export default ConceptosXmlPorXmlId;
